<div class="px-2">
    <div
        class="bg-white item px-md-4 py-2"
        [ngClass]="{
            'px-md-9 py-md-6': size === 'm',
            'px-lg-9 py-md-5': size === 's',
            border: border,
        }"
    >
        <div
            class="px-2"
            [ngClass]="{
                'px-md-4': size === 'm',
                'px-md-3': size === 's',
            }"
        >
            @if (product.image?.url; as url) {
                <img class="img-fluid mb-md-5 mb-2" [src]="url" alt="" />
            }
            @if (!product.image?.url) {
                <img class="img-fluid mb-md-5 mb-2" appProductCatalogue [stelmachID]="product.patternName" alt="" />
            }
        </div>
        <div
            class="lh-1"
            [ngClass]="{
                'px-4': size === 'm',
                'px-3': size === 's',
            }"
        >
            <p class="text-secondary fs-15 fw-700 font-secondary product-name mb-1">
                @if (isNameNum(product.name)) {
                    {{ 'PATTERN.name_num' | translate: { number: product.name } }}
                } @else {
                    <span>{{ product.name }}</span>
                }
            </p>
            <span class="text-gray-300 fs-12 lh-1">{{ product.parameters.width + 'mm' }}</span>
        </div>
    </div>
</div>
